import { money } from "../../lib/dash";

// Local ad-account dates ("2026-11-01") are shown as written: no browser time zone shift.
export const day = (iso, opts = { month: "short", day: "numeric" }) => {
  const [y, m, d] = iso.split("-").map(Number);
  return new Date(Date.UTC(y, m - 1, d)).toLocaleDateString("en-US", { ...opts, timeZone: "UTC" });
};

export const ratio = (x) => (x == null ? "—" : `${x.toFixed(2)}×`);

const purchasesLabel = (wins) => {
  const labels = new Set(wins.map((w) => w.purchases.label));
  return labels.size === 1 ? [...labels][0] : "Purchases (Meta)";
};

const Cell = ({ children, testid, muted }) => (
  <td data-testid={testid} className={`truncate px-1.5 py-px text-right tabular-nums ${muted ? "text-muted-foreground" : ""}`}>{children}</td>
);

const purchaseCell = (w, mixed) =>
  `${w.purchases.count} · ${money(w.purchases.value, w.currency)}${mixed && w.purchases.type ? ` (${w.purchases.type === "omni_purchase" ? "all channels" : "pixel"})` : ""}`;

export const AdsWindows = ({ wins }) => {
  const mixed = new Set(wins.map((w) => w.purchases.label)).size > 1;
  const reason = wins.map((w) => w.roas.reason).find((r) => r && r.includes("currency"));
  const rows = [
    ["spend", "Spend", (w) => money(w.spend, w.currency)],
    ["roas-blended", "Return on ad spend, blended", (w) => (w.roas.blended == null && w.spend <= 0 ? "no spend" : ratio(w.roas.blended))],
    ["roas-meta", "Return on ad spend, Meta-attributed", (w) => ratio(w.roas.meta)],
    ["revenue", "Shop revenue, same hours", (w) => money(w.revenue.revenue, w.revenue.currency)],
    ["purchases", purchasesLabel(wins), (w) => purchaseCell(w, mixed)],
    ["impressions", "Impressions", (w) => w.impressions.toLocaleString("en-US")],
    ["clicks", "Clicks", (w) => w.clicks.toLocaleString("en-US")],
    ["cpc", "Cost per click", (w) => (w.cpc == null ? "—" : money(w.cpc, w.currency))],
  ];
  return (
    <div className="dash-scroll flex min-h-0 flex-1 flex-col overflow-y-auto pr-1">
      <table data-testid="ads-windows" className="w-full table-fixed text-[12px]">
        <thead>
          <tr className="border-b border-border text-[11px] text-muted-foreground">
            <th className="w-[38%] py-0.5 text-left font-medium"> </th>
            {wins.map((w) => (
              <th key={w.id} data-testid={`ads-window-${w.id}`} className="truncate px-1.5 pb-0.5 text-right font-semibold text-foreground">
                {w.id === "today" ? "Today, so far" : w.label}{" "}
                <span className="font-mono2 text-[9.5px] font-normal text-muted-foreground">{w.since === w.until ? day(w.since) : `${day(w.since)}–${day(w.until)}`}</span>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map(([id, label, value]) => (
            <tr key={id} className={`border-b border-border/50 last:border-0 ${id === "spend" ? "font-semibold" : ""}`}>
              <td data-testid={`ads-row-${id}-label`} className="truncate py-px pr-2 text-left text-muted-foreground" title={label}>{label}</td>
              {wins.map((w) => <Cell key={w.id} testid={`ads-${id}-${w.id}`} muted={id.startsWith("roas") && w.roas[id === "roas-meta" ? "meta" : "blended"] == null}>{value(w)}</Cell>)}
            </tr>
          ))}
        </tbody>
      </table>
      {reason && <p data-testid="ads-roas-reason" className="mt-1.5 text-[11px] font-medium text-amber-700">Blended return on ad spend left blank: {reason}.</p>}
    </div>
  );
};
